import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../data/store';
import Modal from './common/Modal';
import { styled } from 'styled-components';
import Button from './common/buttons/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import Config from '../config';
import Link from './common/Link';
import { updateSelf } from '../data/thunks/userThunk';
import Checkbox from './common/form/Checkbox';
import TermsAndConditions from './TermsAndConditions';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { showModal } from '../data/stores/modalStore';

export default function SignupSubscriptionModal() {
	const {
		company: { subscription },
	} = useSelector((state: RootState) => state.companyState);
	const { user } = useSelector((state: RootState) => state.authState);
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const [acceptedTermsAndConditions, setAcceptedTermsAndConditions] =
		useState(false);

	const open =
		subscription?.status === 'incomplete' &&
		!user?.acceptedTermsAndConditions &&
		location.pathname !== '/terms-and-conditions' &&
		location.pathname !== '/company' &&
		location.pathname !== '/signup-company' &&
		location.pathname !== '/login';

	const handleContinue = () => {
		dispatch(
			updateSelf({
				acceptedTermsAndConditions: true,
				acceptedTermsAndConditionsDate: new Date(),
			})
		);
		// TODO: Subscription
		// navigate('/company', { state: { openSubscriptionModal: true } });
		dispatch(showModal({ openId: 'googleWorkspaceVerificationModal' }));
	};

	return (
		<Modal open={open} handleClose={() => {}}>
			<FormContainer>
				<SubscriptionIncomplete
					acceptedTermsAndConditions={acceptedTermsAndConditions}
					setAcceptedTermsAndConditions={
						setAcceptedTermsAndConditions
					}
				/>
				<Button
					style={{
						width: '100%',
						background:
							'linear-gradient(101deg, #4285F4 3.32%, #EA4335 63.03%, #FBBC04 122.74%)',
						marginTop: 24,
					}}
					onClick={handleContinue}
					variant="contained"
					color="primary"
					disabled={
						subscription?.status === 'incomplete' &&
						!acceptedTermsAndConditions
					}
				>
					Setup Google Drive
				</Button>
			</FormContainer>
		</Modal>
	);
}

const SubscriptionIncomplete = (props: {
	acceptedTermsAndConditions: boolean;
	setAcceptedTermsAndConditions: (accepted: boolean) => void;
}) => {
	return (
		<WelcomeContainer>
			<WelcomeHeader>You're almost done!</WelcomeHeader>
			<WelcomeText>
				Review our Terms of Service to get started. Orbito is free
				through the end of the year - no credit card required!
			</WelcomeText>
			<TermsAndConditionsContainer>
				<TermsAndConditions />
			</TermsAndConditionsContainer>
			<Link
				style={{
					display: 'flex',
					alignItems: 'center',
					fontSize: 12,
					marginBottom: 24,
				}}
				onClick={() =>
					window.open(
						`${Config.baseUrl}/terms-and-conditions`,
						'_blank'
					)
				}
			>
				Open Terms of Service in new tab <StyledOpenInNewOutlinedIcon />
			</Link>
			<Checkbox
				size={'small'}
				// onClick={(e) => e.stopPropagation()}
				items={[
					{
						id: 'acceptedTermsAndConditions',
						name: 'I’ve read and acknowledge the Terms of Service',
						checked: props.acceptedTermsAndConditions,
						handleOnChange: () =>
							props.setAcceptedTermsAndConditions(
								!props.acceptedTermsAndConditions
							),
					},
				]}
			/>
		</WelcomeContainer>
	);
};

const StyledOpenInNewOutlinedIcon = styled(OpenInNewOutlinedIcon)`
	margin-left: 5px;
	font-size: 16px !important;
`;

const TermsAndConditionsContainer = styled.div`
	margin-bottom: 8px;
	max-height: 300px;
	overflow-y: auto;
	border: 1px solid ${({ theme }) => theme.palette.divider};
	border-radius: 8px;
	margin-top: 24px;
`;

const MessageContainer = styled.div`
	margin-bottom: 20px;
	text-align: center;

	h2 {
		color: ${({ theme }) => theme.palette.error.main};
		margin-bottom: 16px;
	}

	p {
		margin-bottom: 8px;
	}
`;

const WelcomeContainer = styled.div`
	margin-bottom: 20px;

	h2 {
		margin-bottom: 16px;
	}

	p {
		margin-bottom: 8px;
	}
`;

const FormContainer = styled.div`
	max-width: 600px;
`;

const WelcomeHeader = styled.h2`
	font-size: 32px;
	margin-bottom: 16px;
	color: ${({ theme }) => theme.palette.text.label};
	font-weight: 400;
`;

const WelcomeText = styled.p`
	font-size: 16px;
	margin-bottom: 16px;
	font-weight: 400;
`;
